<div class="lv-spinner-container">
  <div class="lv-spinner-loading" *ngIf="busy">
    <mat-spinner *ngIf="!hideSpinner" color="accent"></mat-spinner>
    <div *ngIf="!hideSpinner" ><h3>{{message}}</h3></div>
  </div>
  <div [ngClass]="{'lv-opaque':busy}">
    <ng-content></ng-content>
  </div>
</div>
